import { GroupTypeDTO } from 'src/AngularJS/Admin/Company/company.model';
import { ICellRendererComp, ICellRendererParams } from 'ag-grid-community';
import { AgentAttributeValueModel } from 'src/shared/models/dashboard.model';

export abstract class AssignToolRightBox {
    /**
     * Called by assign tool to notify the right box that the level or type has changed (the first box).
     * Replaces $scope event `"assignLevelOrTypeChanged"`
     */
    onAssignLevelOrTypeChanged(type: AssignToolItemType, level: number) { }

    /**
     * Needs documentation... used by quite a few right-box components
     * Replaces $scope event `"AssignToolGroupCountEvt"`
     */
    onAssignToolGroupCountEvent(parentGroup: GroupDTO) { }

    /**
     * Called when dataTransfer is empty on the assign tool.
     * Replaces $scope event `"AssignToolUpdateObjectiveEvt"`
     */
    onAssignToolNoData() { }

    /**
     * Called by assign tool to allow the right box to reset as the parent is resetting.
     * Replaces $scope event `"ResetPopup"`
     */
    resetPopup() { }

    /**
     * Called by assign tool to allow the right box to run its own apply code before closing the tool.
     */
    async apply() {
        return;
    }
}

export enum AssignToolItemType {
    EmpGroup = 'emp',
    RecGroup = 'rec',
    Attribute = 'attr',
    Login = 'login'
}

export interface ShowTypeValues {
    emp: boolean;
    rec: boolean;
    agent_att: boolean;
    empAssignAll?: boolean;
    recAssignAll?: boolean;
}

export interface cvAssignmentLists {
    EmpGroupTypes: GroupTypeDTO[];
    RecGroupTypes: GroupTypeDTO[];
}

export interface cvAssignmentToolGroupItem {
    groupDTO: GroupDTO;
    parentPath: string[];
}

export interface cvAssignmentToolWarnings {
    showTemplateWarning: boolean;
    showWriteWarning: boolean;
    showReadControlWarning: boolean;
}

export interface GroupDTO {
    GroupID: number;
    CompanyID: number;
    GroupName: string;
    Active: boolean;
    ParentGroupID: number;
    Group1ID: number;
    Group2ID: number;
    Group3ID: number;
    Group4ID: number;
    Group5ID: number;
    GroupLevel: number;
    BaseGroupType: number;
    Email: string;
    ReceiveAlerts: boolean;
    FirstName: string;
    LastName: string;
    ACDID: number;
    ACDSource: string;
}

export interface LoginApiModel {
    LoginID: number;
    CompanyID: number;
    LoginName: string;
    FirstName: string;
    LastName: string;
    FullName: string;
    GroupID: number;
    RelatedGroupLevel: number;
    RelatedGroupType: number;
    ProfileID: number;
    Active: boolean;
}

export interface AssignToolItemRemovedArgs {
    dto: GroupDTO | AgentAttributeValueModel;
    login?: LoginApiModel;
}

export interface ProfileModel {
    ProfileID: number;
    CompanyID: number;
    ProfileName: string;
    GroupID: number;
    GroupLevel: number;
    GroupType: number;
    GroupTypeStr: string;
}

export default class SingleColCellRenderer implements ICellRendererComp {
    private eGui: HTMLElement;
    private eSpan: HTMLElement;

    init(params: ICellRendererParams) {

        this.eGui = document.createElement('div');
        this.eGui.classList.add('ag_container_for_hover');
        this.eGui.classList.add('w-100');
        this.eGui.style.display = 'flex';
        this.eGui.style.justifyContent = 'space-between';
        this.eGui.style.height = '100%';
        this.eGui.style.alignItems = 'center';

        this.eSpan = document.createElement('span');
        this.eSpan.innerText = params.value;
        this.eSpan.classList.add('text-truncate');

        this.eGui.append(this.eSpan);

        const pic: HTMLImageElement = document.createElement('img');
        pic.src = '../App_Themes/clearview-default/icons/utility/add-16px.svg';
        pic.style.height = '50%';
        pic.style.width = 'auto';
        pic.style.cursor = 'pointer';
        pic.classList.add('visibility_hidden');

        pic.addEventListener('click', (e: MouseEvent) => params.context?.addClicked?.(params.node));

        this.eGui.append(pic);

    }

    refresh() {
        return false;
    }

    getGui(): HTMLElement {
        return this.eGui;
    }
}
